module.exports = __webpack_public_path__ + "img/img21.35b9d6a8.jpg";